import React, { Component } from 'react';
import { store } from '../stores/mainStore';
import styled from 'styled-components';
import { observer } from 'mobx-react';
import { when } from 'mobx';
import { Preloader } from './Preloader';
import { integration } from '../integration';
import {AvaSplashScreen} from './SkillzLobby';

const AcceptTerms = styled.div`
	text-align: center;
	color: white;
	font-size: 4vw;
	text-shadow: 0.5vw 0.5vw 0.5vw #26387a, -0.5vw -0.5vw 0.5vw #26387a, 0.5vw -0.5vw 0.5vw #26387a,
		-0.5vw 0.5vw 0.5vw #26387a;
	flex-grow: 1;
	display: flex;
	justify-content: flex-end;
	flex-direction: column;
`;

@observer
export class Splash extends Component {
	splashEventSent = false;
	acceptedTos = true;
	reloadingTheme = false;

	constructor(props) {
		super(props);
		when(() => store.totalLoadPercentage >= 100,
			() => {
				integration.postEvent('web_preload_end', 'loading')
				setTimeout(() => store.preloading = false, 1000);
			}
		)
		if(localStorage.getItem('reloadingTheme'))
			this.reloadingTheme = true;
	}

	startFTUE() {
		window.manager.startFTUE();
	}
	splashClick = () => {
		store.firstTimeRules = false;
		store.user.loginConfirmed = true;
		store.user.hasSeenTutorial = true;
		
		/* store.firstTimeRules = false;
		if (localStorage.getItem('acceptedTosId') !== null &&
			localStorage.getItem('skippedTutorial') !== 'yes'
		) {
			this.startFTUE();
		} else {
			this.gotoLobby();
		} */
	}

	drawContinue = () =>{	
		console.log(' SPLASH drawContinue')
		setTimeout(()=>{
			if (!this.acceptedTos)	return;
			if (!localStorage.getItem('hasSeenTutorial')) {
				this.startFTUE();
			}
			window.setPersistentStorage('acceptedTosId', store.currentTosId);
			store.acceptedTosId = store.currentTosId;
		}, 500);
		return null;
	};

	gotoLobby = () => {
		// from Login.confirmGuest()
		//store.preventReturnToSplash = true;
		store.user.loginConfirmed = true;
	}

	render() {
		console.log(' SPLASH :: render :: pre =', store.preloading, 'rul =', store.firstTimeRules, 'cur =', store.currentTosId, '!acc =', !store.tosIsAccepted)
		return <SplashPage>
			{store.preloading ? <Preloader/>
			: store.firstTimeRules ? <AvaSplashScreen onClick={this.splashClick}/>
			: store.currentTosId !== -1 ? 
				<AcceptTerms> {this.drawContinue()}</AcceptTerms>
			: null}
		</SplashPage>
	}
}
const SplashPage = styled.div`
	width: 100vw;
	height: 100vh;
	box-sizing: border-box;
	position: relative;
	background: url('/assets/splash/bg_splash.png') center/cover black;
	display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 40vh;
`;